export default __webpack_public_path__ + "e74f8fc2d0135e1f4f66563f908b95cf.png";